import type { Locale } from '$lib/i18n/types';
import type { ClicktripzArrival } from './clicktripz/types';
import { browser } from '$app/environment';
import { env } from '$env/dynamic/public';
import { isNogarnish } from '$lib/utils/nogarnish';
import { checkConsentForClicktripz, setClicktripzInfos, setupClicktripzAd } from './clicktripz';
import { setupItaliaAds } from './italia';
import { setupOrangeAds } from './orange';
import { setupReworldAds } from './reworld';

export function initAds(locale: Locale) {
	if (!browser) {
		return;
	}

	if (!adsEnabled()) {
		return;
	}

	switch (locale) {
		case 'fr-FR':
			return setupOrangeAds();
		case 'it-IT':
			return setupItaliaAds();
		default:
			return setupReworldAds(locale);
	}
}

function adsEnabled() {
	// for ads to be enabled, the env setting must be true and noGarnish must not be set
	return env.PUBLIC_ENABLE_ADS === 'true' && !isNogarnish();
}

export const clicktripz = {
	enabledOnLoad: true,
	setArrival(arrival: ClicktripzArrival) {
		if (!adsEnabled() || !checkConsentForClicktripz()) {
			return;
		}

		setClicktripzInfos(arrival);
		setupClicktripzAd({
			onLoad: () => {
				if (window._CTZ) {
					window._CTZ.enabled = this.enabledOnLoad;
				}
			},
		});
	},
	enable() {
		if (window._CTZ_RELOAD && window._CTZ) {
			window._CTZ.enabled = true;
			window._CTZ_RELOAD();
		} else {
			this.enabledOnLoad = true;
		}
	},
	disable() {
		if (window._CTZ_RELOAD && window._CTZ) {
			window._CTZ.enabled = false;
			window._CTZ_RELOAD();
		} else {
			this.enabledOnLoad = false;
		}
	},
};
